export default __webpack_public_path__ + "static/media/rightInActive.599df84f.svg";